import type { DataProvider, Identifier, ResourceCallbacks } from 'react-admin';

const SIP_DEVICE_IDS_SYMBOL = Symbol('sip_device_ids');

interface ApGroupCallbackRecord {
  id: string;
  sip_devices?: Identifier[];
  [SIP_DEVICE_IDS_SYMBOL]?: Identifier[];
}

const assignSipDevices = async (
  dataProvider: DataProvider,
  apGroupId: Identifier,
  sipDeviceIds: Identifier[]
): Promise<void> => {
  await dataProvider.createMany('sip_devices', {
    data: sipDeviceIds,
    meta: {
      parentId: apGroupId,
      parentResource: 'ap_groups',
    },
  });
};

export const apGroupCallbacks: ResourceCallbacks = {
  resource: 'ap_groups',
  beforeCreate: async (params) => {
    if ('sip_devices' in params.data) {
      const apGroupData = params.data as ApGroupCallbackRecord;
      const sipDeviceIds = apGroupData.sip_devices;
      delete params.data.sip_devices;
      if (sipDeviceIds !== undefined) {
        (params.data as ApGroupCallbackRecord)[SIP_DEVICE_IDS_SYMBOL] = sipDeviceIds;
      }
    }

    return params;
  },
  afterSave: async (data, dataProvider) => {
    const apGroupData = data as ApGroupCallbackRecord;
    const sipDeviceIds = apGroupData[SIP_DEVICE_IDS_SYMBOL];
    apGroupData[SIP_DEVICE_IDS_SYMBOL] = undefined;

    if (sipDeviceIds !== undefined) {
      await assignSipDevices(dataProvider, apGroupData.id, sipDeviceIds);
    }

    return data;
  },
  beforeUpdate: async (params, dataProvider) => {
    if ('sip_devices' in params.data) {
      const sipDeviceIds = params.data.sip_devices as Identifier[] | undefined;
      delete params.data.sip_devices;

      if (sipDeviceIds !== undefined) {
        await assignSipDevices(dataProvider, params.id as Identifier, sipDeviceIds);
      }
    }

    return params;
  },
};
